import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  sender_name: "Ім'я відправника",
  sender_wallet: 'Гаманець відправника',
  last_n_digits: 'Референс транзакції',
  invoice_flow__multi_time_remainin: 'Час, що залишився',
  invoice_flow__multi_or: 'АБО',
  invoice_flow__multi_open_app: 'Відкрити в додатку',
  invoice_flow__multi_return_button: 'Повернутися на веб-сайт',
  invoice_flow__card_transfer_button: 'Підтвердити',

  //Steps
  invoice_flow__multi_upi_qr_step_1: 'Відскануйте або скопіюйте QR-код',
  invoice_flow__multi_upi_qr_step_2: 'Здійсніть оплату',
  invoice_flow__multi_step_3:
    'Для підтвердження оплати вкажіть <b>{attributes}</b> та натисніть кнопку "Підтвердити"',
  invoice_flow__multi_upi_qr_mob_step_1:
    'Відскануйте QR-код або натисніть кнопку "Відкрити в додатку"',

  invoice_flow__multi_bank_transfer_step_1: 'Скопіюйте реквізити',
  invoice_flow__multi_bank_transfer_step_2: 'Здійсніть оплату',

  invoice_flow__card_transfer_step_1: 'Скопіюйте реквізити',
  invoice_flow__card_transfer_step_2:
    'Перекажіть вказану суму (використайте свій банкінг, термінал самообслуговування або зверніться до найближчого відділення банку)',
  invoice_flow__card_transfer_step_3: 'Вкажіть дані для підтвердження: <b>{attributes}</b>',
  invoice_flow__card_transfer_step_4:
    'Після успішного завершення переказу - натисність <b>"Підтвердити"</b>',
};
